import Schedule from './Schedule';

export default Schedule
export { Schedule as Base }